<script setup lang="ts">
interface BreadcrumbItem {
  label: string
  to?: string | object
}

defineProps<{ items: BreadcrumbItem[] }>()
</script>

<template>
  <nav :class="$style['breadcrumb']" aria-label="Breadcrumb">
    <template v-for="(item, index) in items" :key="index">
      <NuxtLink
        v-if="item.to"
        :to="item.to"
        :class="$style['breadcrumb-item']"
      >{{ item.label }}</NuxtLink>
      <span
        v-else
        :class="[$style['breadcrumb-item'], $style['breadcrumb-item--current']]"
        aria-current="page"
      >{{ item.label }}</span>
      <span
        v-if="index < items.length - 1"
        :class="$style['breadcrumb-sep']"
        aria-hidden="true"
      >›</span>
    </template>
  </nav>
</template>

<style module>
.breadcrumb {
  display: flex;
  align-items: center;
  gap: var(--spacing-s);
  flex-wrap: wrap;
}

.breadcrumb-item {
  font-size: var(--font-size-small);
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--duration-micro-fast) var(--easing-transition);
}

/* The public pages: soft links that turn amber */
:global(:where([data-theme="stage"])) .breadcrumb-item {
  color: var(--text-subtle);
}

.breadcrumb-item:hover {
  color: var(--text-subtle);
}

:global(:where([data-theme="stage"])) .breadcrumb-item:hover {
  color: var(--primary-color);
}

.breadcrumb-item--current {
  color: var(--text-base);
  font-weight: var(--font-weight-bold);
}

.breadcrumb-sep {
  color: var(--text-muted);
  font-size: var(--font-size-small);
}
</style>
